import { AdminUser, CampaignError } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const cancelableFetchAdminUsers = async (): Promise<AdminUser[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<AdminUser[]>('admin/users');

const cancelableFetchCampaignErrors = async (): Promise<CampaignError[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<CampaignError[]>(
        'social-campaigns/campaign-errors-report',
    );

export const CancelableAdminUserGateway = {
    cancelableFetchAdminUsers,
    cancelableFetchCampaignErrors,
};
